import {Button, TableCellBaseProps} from 'platform/components';
import {Box, Hide, HStack, Icon, Show, Text} from 'platform/foundation';

import {EMPTY_PLACEHOLDER} from 'shared/web';

import {TableCellType} from '../types/TableCellType';

const MAX_VISIBLE_FILES = 2;

interface DocumentCellFile {
  id: string;
  name: string;
}

interface DocumentCellProps extends TableCellBaseProps<TableCellType> {
  files: DocumentCellFile[];
  fileRequired: boolean;
}

export function DocumentCell(props: DocumentCellProps) {
  const hasFiles = props.files.length > 0;
  const visibleFiles = props.files.slice(0, MAX_VISIBLE_FILES);
  const overflowCount = props.files.length - visibleFiles.length;
  const overflowSuffix = overflowCount > 0 ? ` (+${overflowCount})` : '';
  const displayText = visibleFiles.map((file) => file.name).join(', ') + overflowSuffix;

  return (
    <Box paddingHorizontal={2} overflow="hidden">
      <HStack spacing={2} align="center">
        <Show when={hasFiles}>
          <Button variant="link" title={displayText} size="small" />
        </Show>
        <Hide when={hasFiles}>
          <Show when={props.fileRequired}>
            <Icon value="content/asterisk" size={3} color="severity.danger" />
          </Show>
          <Hide when={props.fileRequired}>
            <Text>{EMPTY_PLACEHOLDER}</Text>
          </Hide>
        </Hide>
      </HStack>
    </Box>
  );
}
